import type { UpdateableAreaSubstrate } from '../../..'
import toSaveableCalculationType from './to-saveable-calculation-type'
import toSaveableRateType from './to-saveable-rate-type'

/**
 *  Convert updateable rate to areaSubstrate rate
 */
export default function toSaveableRate(areaSubstrate: UpdateableAreaSubstrate) {
  const { rate, rateValue } = areaSubstrate

  return {
    rate: {
      int_ext: rate.quoteType,
      section: rate.rateSection,
      name: rate.name,
      label: areaSubstrate.name,
      coverage: Number(rate.coverage),
      client_label: areaSubstrate.clientLabel,
      use_custom: rate.custom,
      rate_type: toSaveableRateType(rate.rateType),
      calculation_type: toSaveableCalculationType(rate.calculationType),
      possible_applications: rate.possibleApplications,
      default_applications: rate.defaultApplications,
      default_width: rate.defaultWidth,
      default_length: rate.defaultLength,
      default_height: rate.defaultHeight,
      values: rate.values,
      notes: rate.notes,
      report_text: rate.reportText,
      areaReportText: rate.areaReportText,
      useCoats: !!rate.useCoats
    },
    rate_value: rateValue?.useCustom ? rateValue.custom : rateValue.default,
    override_rate_value: !!rateValue.useCustom
  }
}
